import React, { FC } from 'react'

import { IconEnvironmentProps } from './IconEnvironment.types'
import * as Styled from './styles/IconEnvironment.style'

import { nonThemeableRules } from '../../ruleSet'

const IconEnvironment: FC<IconEnvironmentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconEnvironmentProps['size'],
  isResponsive = false,
}: IconEnvironmentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M40.858 14.18c-.513 11.455-10.13 20.545-21.595 20.42a21.387 21.387 0 0 1-5.5-.778A21.393 21.393 0 0 1 34.904 7.235h5.947l.006 6.945Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M8.933 40.575A91.895 91.895 0 0 1 31.97 15.877'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconEnvironment
